import React, {useState, useEffect, useRef} from 'react'
import './splashAndDineSlider.css'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6'
 

const SplashAndDineSlider = ({data}) => {
  const [curr, setCurr] = useState(1)
  const slideLength = data.length;
  // Control transition for resets
  const [isTransitioning, setIsTransitioning] = useState(true);
  const sliderRef = useRef(null);

   // Extended slides: [last, 1, 2, 3, first]
    const extendedSlides = [
      data[data.length - 1], // Clone of last slide
      ...data, // Original slides
      data[0], // Clone of first slide
    ];
    // Auto-slide effect
    useEffect(() => {
      const interval = setInterval(() => {
        setCurr((prevIndex) => prevIndex + 1);
        setIsTransitioning(true);
    }, 7000); // Change slide every 7 seconds
  
      return () => clearInterval(interval); // Cleanup on unmount
    }, []);
  
    // Handle transition end to reset index for infinite loop
    useEffect(() => {
      if (curr === extendedSlides.length - 1) {
        // Reached cloned first slide, reset to first real slide
        setTimeout(() => {
          setIsTransitioning(false);
          setCurr(1);
        }, 7000); // Match transition duration
      } else if (curr === 0) {
        // Reached cloned last slide, reset to last real slide
        setTimeout(() => {
          setIsTransitioning(false);
          setCurr(data.length);
        }, 7000); // Match transition duration
      }
    }, [curr, data.length, extendedSlides.length]);
   
    const next = () => {
      setCurr((curr) => curr === slideLength - 1 ? 0 : curr + 1)
    }
    const prev = () => {
      setCurr((curr) => curr === 0 ? slideLength - 1 : curr - 1)
    }
 
  return (
    <section className='carousel-container'>
      <FaChevronLeft className='arrow prev' onClick={prev}/>
      <FaChevronRight className='arrow next' onClick={next}/>
        
      { 
        extendedSlides.map((img, index) => {
          return(
            <div key={index}      
            ref={sliderRef}
             className='carousel' 
             style={{ 
              transform: `translateX(-${curr * 100}%)`,
              transition: isTransitioning ? 'transform 1.5s ease-in-out' : 'none'
             }}
            >

              <img src={img} alt={`Slide ${index}`} />
              {/* <div className='carousel-content'>
                <h1>{img.title}</h1>
              </div> */}
            </div>
        )})
      }

      <div className='carousel-btns'>
        {
          data.map((_, index)=>{
            return(
              <div 
               onClick={(index)=>{ setCurr( index) }}
               key={index}
               className={` ${curr === index ? "active" : "carousel-btn"} `}
              />
            )
          })
        }
      </div>
    </section>
  )
}

export default SplashAndDineSlider